import Vue from "vue";
import Vuex from "vuex";
import VuexLocal from "./PersistenceConfig";

Vue.use(Vuex);

import { EventBus } from "@/utils/EventBus.js";

import UserModule from "./modules/User";
import FilterModule from "./modules/Filter";
import PharmacyDataModule from "./modules/PharmacyData";
import NavSelectionModule from "./modules/NavSelection";
import PricingOptionsModule from "./modules/PricingOptions";
import TabsModule from "./modules/Tabs";
import BlacklistModule from "./modules/Blacklist";
import SaveLoadPricesModule from "./modules/SaveLoadPrices";
import ExportPrices from "./modules/ExportPrices";

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {
        initWithServerData({ dispatch }) {
            return dispatch("getInitialPharmacies")
                .then(() => dispatch("loadPharmacyGroups"))
                .then(() => dispatch("getAllTabs"))
                .then(() => dispatch("loadManufacturers"))
                .catch(error => {
                    console.log(error);
                    EventBus.$emit("getpharmacies-failed");
                });
        },
        getInitialPharmacies({ dispatch, state }) {
            if (state.navSelection.pharmacy) {
                return Promise.resolve(state.navSelection.pharmacy.id);
            } else {
                return dispatch("loadPharmacies").then(response => {
                    return response.data[0].id;
                });
            }
        },
        async getAllTabs({ commit, dispatch, state }) {
            if (state.navSelection.pharmacy.id) {
                let tabs = await dispatch("getPharmacyTabs");
                commit("setTabs", tabs);
            }
        },
        async loadArticleData({ dispatch }) {
            await dispatch("loadArticles");
            await dispatch("calculateAndFilterTabData");
        }
    },
    modules: {
        user: UserModule,
        filter: FilterModule,
        data: PharmacyDataModule,
        navSelection: NavSelectionModule,
        pricingOptions: PricingOptionsModule,
        tabs: TabsModule,
        blacklist: BlacklistModule,
        saveLoadPrices: SaveLoadPricesModule,
        exportPrices: ExportPrices
    },
    plugins: [VuexLocal.plugin]
});
